import React from "react";
import Navbar from "../components/homePage/navBar";
import UpdateInventory from '../components/Inventories/UpdateInventory';

const UpdateInventoryPage: React.FC = () => {
  return (
    <div>
      <Navbar />
      <UpdateInventory />
    </div>
  );
};

export default UpdateInventoryPage;
